<div style="height: calc(100%); width: 100%;" class="ui-dark-background" data-cy="draw-function-container">
  <mat-card appearance="outlined" style="width: 100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="draw-function-card">
    <span class="configuration-section-title" data-cy="draw-function-title">Function Tools</span>
    <app-tdo-configuration-action-bar newHidden="true" (saveClick)="onSave($event)" data-cy="draw-function-action-bar"></app-tdo-configuration-action-bar>
    <mat-card-title data-cy="draw-function-ruler-title">Ruler Object</mat-card-title>
    <mat-card-subtitle data-cy="draw-function-font-subtitle">Ruler object default font.</mat-card-subtitle>
    <div data-cy="draw-function-example-container">
      <p data-cy="draw-function-example-text">Example Text</p>
    </div>

    <table style="width: 618px; border-spacing: 0 8px;" data-cy="draw-function-table">
      <!-- Font Settings Row -->
      <tr data-cy="draw-function-font-row">
        <td style="width: 200px; height: 50px;" data-cy="draw-function-font-field">
          <tdo-dropdown-v2 *ngIf="drawFunctionDefaults" widthString="200px" placeholder="Font" placeholderPosition="above" 
            [datasource]="leadToolsHelper.enumFonts" displayProperty="name" [value]="leadToolsHelper.getFont(this.drawFunctionDefaults.font)" 
            (selectionChange)="onFontChange($event); dropdownChange($event);" data-cy="draw-function-font-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 40px; height: 50px;" data-cy="draw-function-font-size-field">
          <tdo-dropdown-v2 *ngIf="drawFunctionDefaults" widthString="40px" placeholder="Size" placeholderPosition="above" 
            [datasource]="leadToolsHelper.FontSizes" displayProperty="value" [value]="leadToolsHelper.getFontSize(this.drawFunctionDefaults.fontSize)" 
            (selectionChange)="onFontSizeChange($event); dropdownChange($event);" data-cy="draw-function-font-size-dropdown"></tdo-dropdown-v2>
        </td>
        <td style="width: 6px;"></td>
        <td style="width: 200px; height: 50px;" data-cy="draw-function-font-style-field">
          <tdo-dropdown-v2 *ngIf="drawFunctionDefaults" widthString="200px" placeholder="Style" placeholderPosition="above" 
            [datasource]="leadToolsHelper.enumFontStyles" displayProperty="name" [value]="leadToolsHelper.getFontStyle(this.drawFunctionDefaults.fontStyle)" 
            (selectionChange)="onFontStyleChange($event); dropdownChange($event);" data-cy="draw-function-font-style-dropdown"></tdo-dropdown-v2>
        </td>
        <td colspan="2"></td>
      </tr>

      <!-- Colors Subtitle Row -->
      <tr data-cy="draw-function-colors-subtitle-row">
        <td colspan="7">
          <mat-card-subtitle data-cy="draw-function-colors-subtitle">The following is the default foreground and background color for the ruler length.</mat-card-subtitle>
        </td>
      </tr>

      <!-- Colors Row -->
      <tr data-cy="draw-function-colors-row">
        <td colspan="3" data-cy="draw-function-foreground-color-field">
          <app-tdo-color-picker style="width: 100%;" label="Foreground Color" placeholder="Foreground color" [color]="foreground" 
            (colorChange)="onForegroundColorChange($event); configurationService.setDirty();" data-cy="draw-function-foreground-color-picker"></app-tdo-color-picker>
        </td>
        <td style="width: 6px;"></td>
        <td colspan="3" data-cy="draw-function-background-color-field">
          <app-tdo-color-picker style="width: 100%;" label="Background Color" placeholder="Background color" [color]="background" 
            (colorChange)="onBackgroundColorChange($event); configurationService.setDirty();" data-cy="draw-function-background-color-picker"></app-tdo-color-picker>
        </td>
      </tr>

      <!-- Tick Marks Row -->
      <tr data-cy="draw-function-tick-marks-row">
        <td colspan="7">
          <mat-checkbox [checked]="showTickMarks"
            (change)="showTickMarks = $event.checked; configurationService.setDirty();" data-cy="draw-function-tick-marks-checkbox">
            Show the tick marks for rulers.
          </mat-checkbox>
        </td>
      </tr>

      <!-- Gauge Row -->
      <tr data-cy="draw-function-gauge-row">
        <td colspan="7">
          <mat-checkbox [checked]="showGauge"
            (change)="showGauge = $event.checked; configurationService.setDirty();" data-cy="draw-function-gauge-checkbox">
            Show the gauge (perpendicular lines at the ends of the ruler).
          </mat-checkbox>
        </td>
      </tr>
    </table>
  </mat-card>
</div>

